import { TitleColor } from '..';
import Text from '../Text';

const Education2025 = () => (
  <>
    <TitleColor text="Kurser 2025" smallTitle />
    <Text>
      <b>Resolving Challenging Behavior</b>
      <br />1 års Online Efteruddannelse hos Karolina Westlund (PhD):
      <br />
      <i>
        "How to prevent, reduce or eliminate unwanted behaviour, all the while ensuring that the
        animal’s wellbeing and agency isn’t compromised. Teaching ethical, kind and empowering ways
        to bring about behaviour change. A massive interdisciplinary course for animal pros and
        behaviour geeks!"
      </i>
    </Text>
    <Text>
      <b>Michael Shikashio</b>
      <br />
      Kursus den 1-2. februar: Understanding and working with Dog Aggression
    </Text>
  </>
);

export default Education2025;
